import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    device: translate({ id: 'global.device' }),
    notSet: translate({ id: 'global.notSet' }),
    overallMileage: translate({ id: 'global.overallMileage' }),
  }))

  return api
}
